import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { JsonView } from './JsonView';

function getStateFromHash() {
    const text = window.location.hash;
    if (!text) {
        return {};
    }
    return JSON.parse(decodeURIComponent(text.substring(1)));
}

function setStateToHash(value) {
    window.location.hash = encodeURIComponent(JSON.stringify(value));
}

export class RpcLogs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            error: null,
            query: getStateFromHash().rpc_query || JSON.stringify({
                'request.uuid': this.props.userId,
                'method': { $ne: 'Ping' }
            }, null, 4),
            limit: getStateFromHash().rpc_limit || 100,
            from: getStateFromHash().rpc_from || '',
            to: getStateFromHash().rpc_to || '',
        };
    }

    componentDidUpdate() {
        const data = getStateFromHash();
        data.rpc_query = this.state.query;
        data.rpc_limit = this.state.limit;
        data.rpc_from = this.state.from;
        data.rpc_to = this.state.to;
        setStateToHash(data);
    }

    handleTextField = name => event => {
        this.setState({ [name]: event.target.value });
    }

    handleNumberField = name => e => {
        this.setState({ [name]: e.target.value | 0 });
    }

    handleFromField = e => {
        const update = { from: e.target.value };
        this.updateQueryFromDate(e.target.value, this.state.to, update);
        this.setState(update);
    }

    handleToField = e => {
        const update = { to: e.target.value };
        this.updateQueryFromDate(this.state.from, e.target.value, update);
        this.setState(update);
    }

    updateQueryFromDate(from, to, update) {
        try {
            const query = eval(`(${this.state.query})`);
            if (typeof query === 'object') {
                if (from || to) {
                    const time = query.time || (query.time = {});
                    if (from) {
                        time.$gte = from;
                    } else {
                        delete time.$gte;
                    }
                    if (to) {
                        time.$lte = to;
                    } else {
                        delete time.$lte;
                    }
                } else {
                    delete query.time;
                }
                update.query = JSON.stringify(query, null, 4);
            } else {
                console.warn('failed to update query because it\'s ', typeof query);
            }
        } catch (err) {
            console.warn('failed to update query', err);
        }
    }

    handleDateTextField = name => e => {

    }

    componentDidMount() {
        this.startRequest();
    }

    onRefresh = () => {
        this.setState({ loading: true, error: null, data: null });
        this.startRequest();
    }

    startRequest() {
        fetch(`/api/data/search/rpc_logs`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query: eval(`(${this.state.query})`), sort: { time: -1 }, limit: this.state.limit }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, data: result.results });
                }
            });
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        let valid = true;
        let reason = '';
        if (this.state.error) {
            valid = false;
            reason = reason || this.state.error;
        }
        try {
            const query = eval(`(${this.state.query})`);
            if (typeof query !== 'object') {
                valid = false;
                reason = reason || 'Expecting an object instead of ' + (typeof query) + ': ' + this.state.query;
            }
        } catch (err) {
            valid = false;
            reason = reason || err.message;
        }
        window.rpclogs = this.state.data;
        // console.log(this.state.data);
        return (
            <div>
                <div>
                    <b>Make sure your query includes at least of the indexed keys: method, accessToken.uuid, time. If not your query will be very slow.</b>
                </div>
                {!valid && <div style={{ color: 'red' }}>{reason}</div>}
                <div>
                    {false && <TextField label="Limit" type="number" value={this.state.limit} onChange={this.handleNumberField('limit')} />}
                    <TextField label="From" value={this.state.from} onChange={this.handleFromField} />
                    <TextField label="To" value={this.state.to} onChange={this.handleToField} />
                    <Button onClick={this.onRefresh} disabled={!valid}>Refresh</Button>
                </div>
                <textarea rows={10} cols={100} value={this.state.query} onChange={this.handleTextField('query')} />
                <JsonView value={this.state.data} />
            </div>
        );
    }
}

RpcLogs.propTypes = {
    userId: PropTypes.string,
};
